import { renderCopyHover } from 'helpers';

export const renderText = (text: string) =>
  renderCopyHover(text, undefined, { variant: 'caption' });
